'use client';

import { useBookButtonAction } from '@/lib';
import { Place, TypesenseEventDocument } from '@/types';
import { Card, Text } from '@/ui';
import { IconMapPinFilled } from '@tabler/icons-react';
import { format } from 'date-fns';

import { formatTimeRange } from '@/lib/server';
import { getBookButtonText } from '@/lib/utils/get-book-button-text';

export function EventCardLg({ event, place }: { event: TypesenseEventDocument; place: Place | undefined }) {
  const onClick = useBookButtonAction(event, place);

  return (
    <Card
      subtitle={`${format(event.dates, 'EE do MMM')} at ${formatTimeRange(event.dates, event.dates_end) || '6:00 PM'}`}
      image={event.image ?? undefined}
      preserveAspectRatio={event.preserveAspectRatio}
      description={event.shortDescription ?? undefined}
      title={event.eventName}
      actions={{
        primary: {
          children: getBookButtonText(event),
          onClick,
        },
      }}
      key={event.id}
    >
      {place?.custom?.displayName && (
        <Text element="p" className="text-muted-foreground flex items-center gap-2">
          <IconMapPinFilled className="size-4" />
          {place.custom.displayName}
        </Text>
      )}
    </Card>
  );
}
